<script setup lang="ts">
import "./MToolbarTitle.scss";
import type { MToolbarTitleProps } from "./MToolbarTitle.props";

const props = withDefaults(defineProps<MToolbarTitleProps>(), {});
</script>
<template>
  <div class="m-toolbar-title" :class="{ 'm-toolbar-title--shrink': props.shrink }">
    <slot />
  </div>
</template>
